import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Types from "Types";
import {
  ActionCreators as DossierLocationActionCreator,
  Selectors as DossierLocationSelector,
} from "../../redux/DossierLocation";
import { ActionCreators as AdbActionCreator } from "../../redux/AdministrateurDeBien";
import { ActionCreators as PiecesActionCreators } from "../../redux/Pieces";
import Api, { IApi } from "../../services/Api";
import { DossiersLocationProps } from "../../services/Api/DossierLocation";
import {
  Bien,
  DossierLocation,
  Fichier,
  InlineObjectStatutEnum,
  PageDossiersLocation,
  RapportCalculAlgo,
  RetourLocationAcceptee,
} from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";
import { useGetAdbDetail } from "../AdministrateurDeBien";

// export function* redirectionPageCreationBien(
//   api: IApi,
//   action: ActionType<
//     typeof DossierLocationActionCreator.redirectSelectAdbSitePage
//   >
// ) {
//   try {
//     let adbDetail: AdministrateurBienDetail[] = yield select(
//       AdbSelector.getADBDetail
//     );
//     const utilisateurConnecte: Utilisateur = yield select(
//       UtilisateurSelector.getUtilisateurConnecte
//     );
//     const idAdb = yield select(AdbSelector.getAdbId);
//     // si l'utilisateur ADB possède un seul ADB qui lui possède un seul site
//     if (
//       utilisateurConnecte &&
//       utilisateurConnecte.role === "ADB" &&
//       utilisateurConnecte.detailAdbProfilSites &&
//       utilisateurConnecte.detailAdbProfilSites.length === 1 &&
//       utilisateurConnecte.detailAdbProfilSites[0] &&
//       utilisateurConnecte.detailAdbProfilSites[0].sites &&
//       utilisateurConnecte.detailAdbProfilSites[0].sites.length === 1
//     ) {
//       let selectedAdb =
//         adbDetail &&
//         adbDetail.find(
//           (s) =>
//             utilisateurConnecte &&
//             utilisateurConnecte.detailAdbProfilSites &&
//             utilisateurConnecte.detailAdbProfilSites[0] &&
//             s.identifiant === utilisateurConnecte.detailAdbProfilSites[0].refAdb
//         );
//       // si l'adb n'existe pas dans detail, il faut le charger

//       if (!selectedAdb) {
//         const refAdb = utilisateurConnecte.detailAdbProfilSites[0].refAdb || 0;
//         yield* getAdbDetail(
//           api,
//           AdbActionCreator.getADBIdDetail.request(refAdb)
//         );
//         adbDetail = yield select(AdbSelector.getADBDetail);
//         selectedAdb =
//           adbDetail && adbDetail.find((s) => s.identifiant === refAdb);
//       }
//       // après chargement ou si l'adb existait déja dans le tableau de details des adbs
//       if (selectedAdb) {
//         const refSite = utilisateurConnecte.detailAdbProfilSites[0].sites[0];
//         const selectedSite =
//           selectedAdb.sites &&
//           selectedAdb.sites.find((s) => s.numero === refSite);
//         if (selectedSite) {
//           yield put(AdbActionCreator.setSelectedSite(selectedSite));
//           yield put(push("/dossier-location/pre-formulaire"));
//         }
//         // si l'adb n'existe pas dans detail et que le chargement s'est mal passé
//       } else {
//         yield put(push("/dossier-location/selection-adb"));
//       }
//       // si l'utilisateur BESSE est que l'ADB selectionné possède qu'un seul Site
//     } else if (
//       utilisateurConnecte &&
//       utilisateurConnecte.role === "BESSE" &&
//       idAdb &&
//       adbDetail.find((adb) => adb.identifiant === idAdb) &&
//       // @ts-ignore
//       adbDetail.find((adb) => adb.identifiant === idAdb).sites &&
//       // @ts-ignore
//       adbDetail.find((adb) => adb.identifiant === idAdb).sites.length === 1
//     ) {
//       yield put(
//         AdbActionCreator.setSelectedSite(
//           // @ts-ignore
//           adbDetail.find((adb) => adb.identifiant === idAdb).sites[0]
//         )
//       );
//       yield put(push("/dossier-location/pre-formulaire"));
//     } else {
//       yield put(push("/dossier-location/selection-adb"));
//     }
//   } catch (error) {
//     yield put(push("/dossier-location/selection-adb"));
//   }
// }

export const usePostDossierLocation = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());

  const navigate = useNavigate();
  return useMutation<DossierLocation, any, DossierLocation>(
    // @ts-ignore
    (params: DossierLocation) =>
      (api && api.addDossierLocation(params)) || undefined,
    {
      onSuccess: (data: DossierLocation, variables: DossierLocation) => {
        if (variables.candidatLocataire) {
          dispatch(
            DossierLocationActionCreator.confirmationDossierLocationParcoursCreation()
          );
          navigate("/dashboard");
        } else {
          dispatch(
            DossierLocationActionCreator.createOrUpdateDossierLocationAsync.success(
              data
            )
          );
          navigate("/dossier-location/situation-personnelle");
        }
      },
      onError: (error, variables) => {
        dispatch(
          DossierLocationActionCreator.createOrUpdateDossierLocationAsync.failure(
            error
          )
        );
      },
    }
  );
};

export const usePutDossierLocation = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  const navigate = useNavigate();
  return useMutation<DossierLocation, any, DossierLocation>(
    // @ts-ignore
    (params: DossierLocation) =>
      (api && api.updateDossierLocation(params)) || undefined,
    {
      onSuccess: (data: DossierLocation, variables: DossierLocation) => {
        dispatch(
          DossierLocationActionCreator.createOrUpdateDossierLocationAsync.success(
            variables
          )
        );
        navigate("/dossier-location/situation-personnelle");
      },
      onError: (error) => {
        dispatch(
          DossierLocationActionCreator.createOrUpdateDossierLocationAsync.failure(
            error
          )
        );
      },
    }
  );
};

// export function* addOrUpdateDossierLocation(
//   api: IApi,
//   action: ActionType<
//     typeof DossierLocationActionCreator.createOrUpdateDossierLocationAsync.request
//   >
// ) {
//   try {
//     // dossier de location est celui du state local du component
//     // old dossier location est celui qui est en store en cas de modification
//     // le dossier store ne sera modifié que si la création ou modification
//     // c-à-dire (appel HTTP) se passe bien
//     // à la création on n'a pas de dossier dans le store
//     const dossierLocation: DossierLocation = action.payload;
//     let resultat;
//     // en cas de modification
//     if (dossierLocation.reference) {
//       const oldDossierLocation: DossierLocation = yield select(
//         DossierLocationSelector.getDossierLocation
//       );
//       // si on detect un changement de type de dossier on supprime le conjoint
//       // côté back, il y aura une suppression des dossiers secondaires
//       if (
//         oldDossierLocation &&
//         oldDossierLocation.compositionLocation !==
//           dossierLocation.compositionLocation
//       ) {
//         yield put(
//           SituationPersonnelleActionCreator.removeSituationPersonnelleConjoint()
//         );
//       }
//       yield call(api.updateDossierLocation, dossierLocation);
//       resultat = dossierLocation;
//       // en cas de création
//     } else {
//       resultat = yield call(api.addDossierLocation, dossierLocation);
//     }
//     yield put(
//       DossierLocationActionCreator.createOrUpdateDossierLocationAsync.success(
//         resultat
//       )
//     );
//     yield put(push("/dossier-location/bien"));
//   } catch (error) {
//     yield put(
//       DossierLocationActionCreator.createOrUpdateDossierLocationAsync.failure(
//         error
//       )
//     );
//   }
// }

export const useGetSyntheseDossier = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dispatch = useDispatch();
  const refPath = new URLSearchParams(document.location.search).get(
    "refDossier"
  );
  const { mutate: mutateADBIdDetail } = useGetAdbDetail();
  return useMutation<DossierLocation, any, string>(
    // @ts-ignore
    (params: string) => (api && api.getSyntheseDossier(params)) || undefined,
    {
      onSuccess: (data: DossierLocation) => {
        dispatch(DossierLocationActionCreator.getSyntheseDossier.success(data));

        const id = data?.referenceAdb;
        if (refPath && id) {
          mutateADBIdDetail(id);
          dispatch(AdbActionCreator.updateAdbId(id));
        }
      },
      onError: (error, variables) => {
        dispatch(
          DossierLocationActionCreator.getSyntheseDossier.failure(error)
        );
      },
    }
  );
};

export const useGetDossiersLocation = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();

  return useMutation<PageDossiersLocation, any, DossiersLocationProps>(
    // @ts-ignore
    (params: DossiersLocationProps) =>
      (api && api.getDossiersLocation(params)) || undefined,
    {
      onSuccess: (data: PageDossiersLocation) => {
        dispatch(
          DossierLocationActionCreator.getDossiersLocation.success(data)
        );
      },
      onError: (error, variables) => {
        dispatch(
          DossierLocationActionCreator.getDossiersLocation.failure(error)
        );
      },
    }
  );
};

export const useGetArchiveNetheos = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dispatch = useDispatch();
  return useMutation<
    PageDossiersLocation,
    any,
    { ref: string; refPers: string }
  >(
    // @ts-ignore
    (params: { ref: string; refPers: string }) =>
      (api && api.getArchiveNetheos(params)) || undefined,
    {
      onSuccess: (data: Blob) => {
        dispatch(PiecesActionCreators.getArchiveNetheos.success(data));

        const blob = new Blob([data], { type: "application/zip" });
        const link = document.createElement("a");
        link.setAttribute("download", "documents");
        link.setAttribute("href", window.URL.createObjectURL(blob));
        document.body.appendChild(link);
        link.click();
      },
      onError: (error, variables) => {
        dispatch(PiecesActionCreators.getArchiveNetheos.failure(error));
      },
    }
  );
};

// export function* getRapportAlgo(
//   api: IApi,
//   action: ActionType<typeof DossierLocationActionCreator.getRapportAlgo.request>
// ) {
//   try {
//     const result: RapportCalculAlgo = yield call(
//       api.getRapportAlgo,
//       action.payload
//     );
//     yield put(DossierLocationActionCreator.getRapportAlgo.success(result));
//   } catch (error) {
//     yield put(DossierLocationActionCreator.getRapportAlgo.failure(error));
//   }
// }

export const useGetRapportAlgo = () => {
  const api: IApi = Api.create(getApiEndpoint());

  // @ts-ignore
  return useMutation<RapportCalculAlgo, any, string>(
    (params: string) => (api && api.getRapportAlgo(params)) || undefined,
    {
      onSuccess: (data: RapportCalculAlgo) => {
        DossierLocationActionCreator.getRapportAlgo.success(data);
      },
      onError: (error, variables) => {
        DossierLocationActionCreator.getRapportAlgo.failure(error);
      },
    }
  );
};

export const useRouvrirDossierNetheos = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();
  // @ts-ignore
  return useMutation<
    void,
    any,
    {
      ref: string;
      refPers: string;
    }
  >(
    // @ts-ignore
    (params: { ref: string; refPers: string }) =>
      (api && api.rouvrirDossierNetheos(params)) || undefined,
    {
      onSuccess: (data: void) => {
        dispatch(PiecesActionCreators.rouvrirDossierNetheos.success());
      },
      onError: (error, variables) => {
        dispatch(PiecesActionCreators.rouvrirDossierNetheos.failure(error));
      },
    }
  );
};

export const useCalculLoyerMax = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();
  const selectedDossier = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getSelectedDossier(state)
  );
  const { mutate: getSyntheseDossier } = useGetSyntheseDossier();
  // @ts-ignore
  return useMutation<void, any, string>(
    // @ts-ignore
    (params: string) => (api && api.calculLoyerMax(params)) || undefined,
    {
      onSuccess: (data: void) => {
        selectedDossier && getSyntheseDossier(selectedDossier);
      },
      onError: (error, variables) => {
        dispatch(
          DossierLocationActionCreator.getSyntheseDossier.failure(error)
        );
      },
    }
  );
};

export const useDeleteDossierLocation = () => {
  const api: IApi = Api.create(getApiEndpoint());
  // @ts-ignore
  return useMutation<void, any, string>(
    // @ts-ignore
    (params: string) => (api && api.deleteDossierLocation(params)) || undefined,
    {}
  );
};

export const useGenererCertification = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();
  // @ts-ignore
  return useMutation<Blob, any, string>(
    // @ts-ignore
    (params: string) => (api && api.genererCertification(params)) || undefined,
    {
      onSuccess: (data: Blob) => {
        dispatch(
          DossierLocationActionCreator.genererCertification.success(data)
        );

        // const url = window.URL.createObjectURL(b64toBlob(result));
        const link = document.createElement("a");
        link.href = "data:application/pdf;base64," + data;
        link.setAttribute("download", "certificatAgrement.pdf");
        document.body.appendChild(link);
        link.target = "_blank";
        link.click();
      },
      onError: (error, variables) => {
        dispatch(
          DossierLocationActionCreator.genererCertification.failure(error)
        );
      },
    }
  );
};

export const useDupliquerDossier = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const setSelectedDossier = (refLocation: string) => {
    dispatch(DossierLocationActionCreator.setSelectedDossier(refLocation));
  };
  return useMutation<DossierLocation, any, { ref: string; bien: Bien }>(
    // @ts-ignore
    (params: { ref: string; bien: Bien }) =>
      (api && api.dupliquerDossier(params)) || undefined,
    {
      onSuccess: (data: DossierLocation) => {
        dispatch(DossierLocationActionCreator.dupliquerDossier.success(data));
        if (data.reference) {
          setSelectedDossier(data.reference);
        }
        navigate("/dossier-location/synthese");
      },
      onError: (error, variables) => {
        dispatch(DossierLocationActionCreator.dupliquerDossier.failure(error));
      },
    }
  );
};

export const useAccepterDossier = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();

  const filtreRecherche = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getFiltreRechercheDossierLocation(state)
  );
  const { mutate: getDossiersLocation } = useGetDossiersLocation();

  return useMutation<RetourLocationAcceptee, any, string>(
    // @ts-ignore
    (params: string) => (api && api.accepterDossier(params)) || undefined,
    {
      onSuccess: (data: RetourLocationAcceptee) => {
        dispatch(DossierLocationActionCreator.accepterDossier.success(data));

        getDossiersLocation(filtreRecherche);
      },
      onError: (error, variables) => {
        dispatch(DossierLocationActionCreator.accepterDossier.failure(error));
      },
    }
  );
};

export const useAnnulerAcceptationDossier = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();

  const filtreRecherche = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getFiltreRechercheDossierLocation(state)
  );
  const { mutate: getDossiersLocation } = useGetDossiersLocation();
  return useMutation<void, any, string>(
    // @ts-ignore
    (params: string) =>
      (api && api.annulerAcceptationDossier(params)) || undefined,
    {
      onSuccess: (data: void) => {
        dispatch(
          DossierLocationActionCreator.annulerAcceptationDossier.success()
        );
        getDossiersLocation(filtreRecherche);
      },
      onError: (error, variables) => {
        dispatch(
          DossierLocationActionCreator.annulerAcceptationDossier.failure(error)
        );
      },
    }
  );
};

export const useForcerStatutDossier = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();
  const selectedDossier = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getSelectedDossier(state)
  );
  const { mutate: getSyntheseDossier } = useGetSyntheseDossier();
  return useMutation<
    RetourLocationAcceptee,
    any,
    { ref: string; statut: InlineObjectStatutEnum; message: string }
  >(
    // @ts-ignore
    (params: {
      ref: string;
      statut: InlineObjectStatutEnum;
      message: string;
    }) => (api && api.forcerStatutDossier(params)) || undefined,
    {
      onSuccess: (data: void) => {
        dispatch(DossierLocationActionCreator.forcerStatutDossier.success());
        selectedDossier && getSyntheseDossier(selectedDossier);
      },
      onError: (error, variables) => {
        dispatch(
          DossierLocationActionCreator.forcerStatutDossier.failure(error)
        );
      },
    }
  );
};

export const useVerifierDossierLocation = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const { mutate: mutateSynthese } = useGetSyntheseDossier();
  return useMutation<void, any, string>(
    // @ts-ignore
    (params: string) =>
      (api && api.verifierDossierLocation(params)) || undefined,
    {
      onSuccess: (data: void, variables: string) => {
        mutateSynthese(variables);
      },
    }
  );
};

export const usePostDossierParticulierDocument = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const { mutate: mutateSynthese } = useGetSyntheseDossier();
  return useMutation<
    number,
    any,
    {
      dossierLocationRef: string;
      dossierParticulierRef: string;
      fichier: Fichier;
    }
  >(
    // @ts-ignore
    (params: {
      dossierLocationRef: string;
      dossierParticulierRef: string;
      fichier: Fichier;
    }) => (api && api.postDossierParticulierDocument(params)) || undefined,
    {
      onSuccess: (
        data: number,
        variables: {
          dossierLocationRef: string;
          dossierParticulierRef: string;
          fichier: Fichier;
        }
      ) => {
        mutateSynthese(variables.dossierLocationRef);
      },
    }
  );
};
